import {
  // eslint-disable-next-line camelcase
  legacy_createStore,
  applyMiddleware,
  combineReducers,
  compose,
} from 'redux';
import thunk from 'redux-thunk';
import {persistStore} from 'redux-persist';
import {createLogger} from 'redux-logger';
import {reducer as formReducer} from 'redux-form';
import auth from './auth';
import grid from './grid';
import menu from './menu';
import style from './style';
import master from './master';
import common from './common';
import runstat from './runstat';
import setting from './setting';
import sidebar from './sidebar';
import snackbar from './snackbar';
import persist from './persist';
import appConfig from '@/config';

// Redux リデューサー設定
const appReducer = combineReducers({

  // ローカルストレージに保存
  auth: persist.local('auth', auth),           // 認証ユーザー情報
  sidebar: persist.local('sidebar', sidebar),  // サイドバー開閉状態
  setting: persist.local('setting', setting),  // 画面設定

  // セッションストレージに保存
  master: persist.session('master', master),     // マスター情報
  runstat: persist.session('runstat', runstat),  // 業務運用状態
  form: persist.session(
      'form', formReducer,    // フォーム入力状態 
      ['Login']),             // (ログイン画面を除く)

  // ストレージ保存なし
  menu: persist.none(menu),
  grid: persist.none(grid),
  style: persist.none(style),
  common: persist.none(common),
  snackbar: persist.none(snackbar),
});

// Redux ミドルウェア設定
const middlewares = [];
middlewares.push(thunk);

// Redux ロガー設定
if (appConfig.logger) {
  const logger = createLogger({
    diff: true,
    collapsed: true,
  });
  middlewares.push(logger);
}

// Redux ストア設定
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = legacy_createStore(
    appReducer,
    window.REDUX_INITIAL_DATA,
    composeEnhancers(applyMiddleware(...middlewares)),
);
export const persistor = persistStore(store);
export default function configureStore(initialState = {}) {
  return store;
}
